module.exports = __webpack_public_path__ + "img/damage_detail_blaupause_dark.737e90aa.gif";